import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import actions from '../../../store/actions';

import './index.scss';

class ChatHeader extends React.Component {
  disposeBot = (event) => {
    event.preventDefault();
    const chat = document.getElementById('bot-test-chat');
    chat.classList.toggle('is-chat-open');

    setTimeout(() => {
      const { closeBot, closeConnection, closePreviewChat } = this.props;
      closeConnection();
      closeBot();
      if (closePreviewChat) {
        closePreviewChat();
      }
    }, 1000);
  };

  reset = (event) => {
    event.preventDefault();
    const { resetPreview } = this.props;
    resetPreview();
  };

  render() {
    const { title, firstTest } = this.props;
    return (
      <header className="chat-box__header">
        <img
          className="chat-box__header__icon"
          src={require('../../../assets/images/testar.svg')}
          alt="Icone modo teste"
        />
        <span>Preview:&nbsp;</span>
        <strong>{title}</strong>
        {firstTest === false && (
          <a onClick={this.reset} href="#/">
            <img
              src="/assets/images/chat-box/icon-restart.svg"
              alt="Reiniciar bot"
              className="chat-box__header__restart"
            />
          </a>
        )}
        <img
          className="chat-box__header__close pointer"
          src={require('../../../assets/images/ic_close.svg')}
          alt=""
          onClick={this.disposeBot}
        />
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  firstTest: state.previewBot.firstTest,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actions.previewBot, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChatHeader);
